import { AttioSortDirection, AttioValuationFilter } from 'dashboard409a/common/constants/analyst-dashboard';
import { AttioValuationService } from './attio/AttioValuationService';
import { SimplifiedAttioValuation } from './attio.types';

// Create a singleton instance of the valuation service
const valuationService = new AttioValuationService();

export const createAttioSort = (orderBy: string, order: AttioSortDirection) =>
  AttioValuationService.createAttioSort(orderBy, order);

export const updateValuation = (valuationId: string, valuation: SimplifiedAttioValuation) =>
  valuationService.updateValuation(valuationId, valuation);

export const getAllAttioValuations = (params: {
  userRecordId: string;
  filters: AttioValuationFilter;
}) => valuationService.getAllValuations(params);

export const loadBulkNotes = (attioValuationIds: string[]) =>
  valuationService.loadBulkNotes(attioValuationIds);
